import { UrlHelper } from "./../../../shared/helpers/url-helpers";
import { IDocumentModel } from "./../../interfaces/document-model";
import { ITabDefinition } from "./../../interfaces/tab-definition";
import { GenericTabModel } from "./generic-tab";
import { ReportDetailModel } from "./../report-detail";
import {prop} from "../../../decorators/property";
import { ReportTabState } from "./report-state";
import { AuthorizationModel } from "../../../authentication/models/authorization-model";
import { AppSettings } from "../../../app-settings";

export class ReportTabModel extends GenericTabModel {
    @prop() public ReportDetails: ReportDetailModel[];
    @prop() public State: ReportTabState = new ReportTabState();

    public constructor(properties: ITabDefinition, docModel: IDocumentModel, reportDetails: ReportDetailModel[]) {
        super(properties, docModel);
        this.ReportDetails = reportDetails;
        this.Identifier = "report-" + UrlHelper.replaceSpaces(reportDetails[0].ReportName).toLowerCase();
        this.Source = reportDetails[0].Source;
    }

    public getReportFulltextFromServer(reportSource: string, id: string, index: number): Promise<any> {
        return new Promise<string>((resolve, reject) => {
            $.ajax({
                beforeSend: AuthorizationModel.attachAuthorizationHeader,
                type: "GET",
                cache: false,
                url: `${AppSettings.DocumentApiUrlPrefix}report/fulltext/${reportSource}/${id}/${index}`,
            }).done(resolve).fail(reject);
        });
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/tabs/report.ts